import {Component, Input, OnChanges, OnInit, SimpleChanges} from '@angular/core';
import {CsvDataWithFieldName} from '../CsvDataWithFieldName';

@Component({
  selector: 'app-csv-column-preview',
  templateUrl: './csv-column-preview.component.html',
  styleUrls: ['./csv-column-preview.component.scss']
})
export class CsvColumnPreviewComponent implements OnInit, OnChanges {

  @Input()
  csvData: CsvDataWithFieldName[];

  @Input()
  column: string;

  columnFields: string[];

  constructor() {
  }

  ngOnInit(): void {
    this.columnFields = [];
    if (this.column) {
      this.extractColumnData(this.csvData, this.column);
    }
  }

  private extractColumnData(csv: CsvDataWithFieldName[], column: string) {
    if (!csv) { return; }

    csv.map(el => {
      this.columnFields.push(el[column]);
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.csvData || changes.column) {
      this.columnFields = [];
      this.extractColumnData(this.csvData, this.column);
    }
  }
}
